/* eslint-disable @typescript-eslint/naming-convention */
import { LocalStorage, SESSION_STORAGE_KEYS } from "@swiggy-private/core-ui";
import { ORIGINAL_BUSINESS_LINE } from "@checkout-core/constants/Metrics";
import { CartType } from "@checkout-core/constants/Cart";

export const PRE_CART_LINK_KEY = "swgy_mweb_static_web_food_cart_session_prev_link";

// Singleton fallback for environments where both sessionStorage and window are unavailable (e.g. SSR)
let IN_MEMORY_CART_TYPE = "";

export const getPreCartLinkFromStorage = (): string => {
    if (typeof window !== "undefined" && typeof window.sessionStorage !== "undefined") {
        try {
            return String(sessionStorage.getItem(PRE_CART_LINK_KEY) || "");
        } catch (_) {
            return "";
        }
    }
    return "";
};

export const clearAuthHeadersFromStorage = (): void => {
    LocalStorage.removeItem("auth_headers");
};

export function setCartTypeInSession(cartData: { irctc_data?: unknown }): void {
    IN_MEMORY_CART_TYPE = cartData?.irctc_data != null ? CartType.IRCTC : "";

    if (typeof window !== "undefined") {
        window.__CART_TYPE__ = IN_MEMORY_CART_TYPE;

        if (typeof window.sessionStorage !== "undefined") {
            try {
                sessionStorage.setItem(SESSION_STORAGE_KEYS.CART_TYPE, IN_MEMORY_CART_TYPE);
            } catch (_) {
                // sessionStorage may be unavailable (e.g. private browsing restrictions)
            }
        }
    }
}

export function getCartTypeFromSession(): string {
    if (typeof window !== "undefined") {
        const inMemoryCartType = window.__CART_TYPE__ || IN_MEMORY_CART_TYPE;
        if (typeof window.sessionStorage !== "undefined") {
            try {
                return sessionStorage.getItem(SESSION_STORAGE_KEYS.CART_TYPE) ?? inMemoryCartType;
            } catch (_) {
                return inMemoryCartType;
            }
        }
        return inMemoryCartType;
    }
    return IN_MEMORY_CART_TYPE;
}

export function getOriginalBusinessLine(): string | null {
    // possible values are string or null, null in case local storage is not available
    const originalBusinessLine = LocalStorage.getItem(ORIGINAL_BUSINESS_LINE, null);
    return originalBusinessLine as string | null;
}
